import { render, staticRenderFns } from "./agGrid.vue?vue&type=template&id=1244683b"
import script from "./agGrid.vue?vue&type=script&lang=js"
export * from "./agGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports